import React, { Component, Fragment } from 'react';
import { connect } from 'react-redux';
import autobind from 'autobind-decorator';
import WindowEventHelper from '../../../lib/WindowEventHelper';
import PreviewLayerHeader from './PreviewLayerHeader';
import PreviewLayerFooter from './PreviewLayerFooter';

import { PRESET_PC, PRESET_TYPE_PC, PRESET_MOBILE_1 } from '../../../constants/PreviewPreset';
import { STATUS_EDITOR } from '../../../constants/EditorStatus';
import { changeEditorStatus } from '../../../actions';

@connect(state => ({
  blog: state.blog,
  post: state.post.newPost,
}), dispatch => ({
  handleClosePreviewStatus () {
    dispatch(changeEditorStatus(STATUS_EDITOR));
  },
}))
class PreviewLayer extends Component {
  constructor (props) {
    super(props);
    this.state = {
      preset: PRESET_PC,
      width: PRESET_PC.width,
      height: PRESET_PC.height,
      isCustom: false,
    };

    this.previewForm = React.createRef();
  }

  componentDidMount () {
    WindowEventHelper.add('resize', this.handleResizeWindow);

    this.setPreviewSize(PRESET_PC, window.innerWidth, window.innerHeight);
    this.previewForm.current.submit();
  }

  componentWillUnmount () {
    WindowEventHelper.remove('resize', this.handleResizeWindow);
  }

  componentDidUpdate (prevProps, prevState, snapshot) {
    const { preset } = this.state;
    if (prevState.preset.type !== this.state.preset.type) {
      const form = this.previewForm.current;
      form.action = appInfo.manageUrl + (preset.type === PRESET_TYPE_PC ? '/preview.php' : '/previewMobilePost.php');
      form.submit();
    }
  }

  setPreviewSize (preset, width, height, isCustom) {
    width = width || window.innerWidth;
    height = height || window.innerHeight;
    this.setState({
      preset,
    });

    const boxWidth = window.innerWidth - 120;
    const boxHeight = window.innerHeight;

    if (boxWidth < width) {
      width = boxWidth;
    }
    if (width < PRESET_MOBILE_1.width) {
      width = PRESET_MOBILE_1.width;
    }

    if (boxHeight - 73 < height) {
      height = boxHeight - 73;
    }
    if (height < PRESET_MOBILE_1.height) {
      height = PRESET_MOBILE_1.height;
    }

    this.setState({
      preset,
      width,
      height,
      isCustom,
    });
  }

  @autobind
  handleResizeWindow () {
    const { preset, width, height, isCustom } = this.state;
    if (isCustom) {
      this.setPreviewSize(preset, width, height, isCustom);
    } else {
      this.setPreviewSize(preset, preset.width, preset.height, isCustom);
    }
  }

  @autobind
  handleUsePreset (preset) {
    this.setPreviewSize(preset, preset.width, preset.height, false);
  }

  @autobind
  handleChangeWidth (value) {
    const { preset, height } = this.state;
    this.setPreviewSize(preset, value, height, true);
  }

  @autobind
  handleChangeHeight (value) {
    const { preset, width } = this.state;
    this.setPreviewSize(preset, width, value, true);
  }

  render () {
    const { blog, post, onClose } = this.props;
    const { preset, width, height } = this.state;
    const iframeSizeStyle = {
      width: `${width}px`,
      height: `${height}px`,
    };

    return (
      <Fragment>
        <PreviewLayerHeader
          preset={preset}
          width={width}
          height={height}
          onChangePreset={this.handleUsePreset}
          onChangeWidth={this.handleChangeWidth}
          onChangeHeight={this.handleChangeHeight}
        />

        <div className={'layer_body'}>
          <iframe src={''} name={'previewIframe'} style={iframeSizeStyle} sandbox={'allow-scripts'} />
          <form ref={this.previewForm} action={`${appInfo.manageUrl}/preview.php`} method={'post'} target={'previewIframe'}>
            <input type={'hidden'} name={'id'} value={post.id} />
            <input type={'hidden'} name={'title'} value={post.title} />
            <input type={'hidden'} name={'content'} value={post.content} />
            <input type={'hidden'} name={'slogan'} value={post.slogan} />
            <input type={'hidden'} name={'category'} value={post.category} />
            <input type={'hidden'} name={'tag'} value={post.tags.join(',')} />
            <input type={'hidden'} name={'uselessMarginForEntry'} value={blog.uselessMargin} />
          </form>
        </div>

        <PreviewLayerFooter onClose={onClose} />
      </Fragment>
    );
  }
}

export default PreviewLayer;
